import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import { createRoot } from 'react-dom/client';

import App from './App';
import './i18n';
import './style/base.css';
import { actionHistory } from './util';

dayjs.extend(utc);

async function enableMocking() {
  const { startMocking } = await import('./mock/browser');
  return startMocking();
}

if (import.meta.env.DEV && import.meta.env.VITE_APP_MSW_ENABLED == 1) {
  enableMocking();
}

if (!import.meta.env.DEV) {
  actionHistory.start();
}

createRoot(document.getElementById('app')!).render(<App />);

!import.meta.env.DEV &&
  console.log(`
                                                                                                                                  
   SSSSSSSSSSSSSSS                                                                                                                
 SS:::::::::::::::S                                                                                                               
S:::::SSSSSS::::::S                                                                                                               
S:::::S     SSSSSSS                                                                                                               
S:::::S              aaaaaaaaaaaaa  ppppp   ppppppppp   ppppp   ppppppppp      ooooooooooo   rrrrr   rrrrrrrrr      ooooooooooo   
S:::::S              a::::::::::::a p::::ppp:::::::::p  p::::ppp:::::::::p   oo:::::::::::oo r::::rrr:::::::::r   oo:::::::::::oo 
 S::::SSSS           aaaaaaaaa:::::ap:::::::::::::::::p p:::::::::::::::::p o:::::::::::::::or:::::::::::::::::r o:::::::::::::::o
  SS::::::SSSSS               a::::app::::::ppppp::::::ppp::::::ppppp::::::po:::::ooooo:::::orr::::::rrrrr::::::ro:::::ooooo:::::o
    SSS::::::::SS      aaaaaaa:::::a p:::::p     p:::::p p:::::p     p:::::po::::o     o::::o r:::::r     r:::::ro::::o     o::::o
       SSSSSS::::S   aa::::::::::::a p:::::p     p:::::p p:::::p     p:::::po::::o     o::::o r:::::r     rrrrrrro::::o     o::::o
            S:::::S a::::aaaa::::::a p:::::p     p:::::p p:::::p     p:::::po::::o     o::::o r:::::r            o::::o     o::::o
            S:::::Sa::::a    a:::::a p:::::p    p::::::p p:::::p    p::::::po::::o     o::::o r:::::r            o::::o     o::::o
SSSSSSS     S:::::Sa::::a    a:::::a p:::::ppppp:::::::p p:::::ppppp:::::::po:::::ooooo:::::o r:::::r            o:::::ooooo:::::o
S::::::SSSSSS:::::Sa:::::aaaa::::::a p::::::::::::::::p  p::::::::::::::::p o:::::::::::::::o r:::::r            o:::::::::::::::o
S:::::::::::::::SS  a::::::::::aa:::ap::::::::::::::pp   p::::::::::::::pp   oo:::::::::::oo  r:::::r             oo:::::::::::oo 
 SSSSSSSSSSSSSSS     aaaaaaaaaa  aaaap::::::pppppppp     p::::::pppppppp       ooooooooooo    rrrrrrr               ooooooooooo   
                                     p:::::p             p:::::p                                                                  
                                     p:::::p             p:::::p                                                                  
                                    p:::::::p           p:::::::p                                                                 
                                    p:::::::p           p:::::::p                                                                 
                                    p:::::::p           p:::::::p                                                                 
                                    ppppppppp           ppppppppp                                                                 
                                                                                                                                    
`);
